<template>
  <div>
    <div v-if="$auth.check('employee') || isAdmin()">
      <button 
        class="ui blue button" 
        style="background-color: #092442"
        @click="
          navigateTo('Update_Patient', {
            key: 'params',
            value: {
              id: 'new'
            }
          })
        "
      >
        <i class="users icon"></i>
        New patient
      </button>
      <button 
        class="ui teal button" 
        style="background-color: #092442"
        @click="navigateTo('New_Reservation')"
      >
        <i class="file icon"></i>
        New reservation
      </button>
      <button 
        class="ui teal button" 
        style="background-color: #092442"
        @click="navigateTo('New_Expense_Transaction')"
        v-if="$auth.user().can_make_transaction"
      >
        <i class="money bill alternate outline icon"></i>
        New Expense
      </button>
      <button 
        class="ui blue button" 
        style="background-color: #092442"
        @click="navigateTo('Transaction_Audit_Report')"
      >
        <i class="calculator icon"></i>
        Cover sheet
      </button>
      <div class="ui divider" />
    </div>
    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div v-else>
      <div class="ui horizontal list" v-if="useDoctors && ($auth.check('employee') || isAdmin())">
        <div class="item" v-for="doctor in filteredDoctors()" :key="doctor.id">
          <div class="content">
            <button class="ui gray button" 
              :class="{basic: currentDoctorId !== doctor.id}"
              @click="chooseDoctor(doctor.id)"
            >
              {{ doctor.user.name }}
            </button>
          </div>
        </div>
      </div>
      <div class="ui horizontal list" v-if="useRooms && ($auth.check('employee') || isAdmin())">
        <div class="item" v-for="room in filteredRooms()" :key="room.id">
          <div class="content">
            <button class="ui gray button" 
              :class="{basic: currentRoomId !== room.id}"
              @click="chooseRoom(room.id)"
            >
              {{ room.name }}
            </button>
          </div>
        </div>

      </div>
      <div class="ui hidden divider" />
      <room :roomId="currentRoomId" :key="roomKey" v-if="currentRoomId && useRooms"/>
      <doctorVisits :doctorId="currentDoctorId" :key="roomKey" v-if="currentDoctorId && useDoctors"/>
      <div v-if="!useDoctors && !useRooms">
        <div class="ui placeholder segment" style="margin-bottom: 50px">
          <div class="ui icon header" style="color: #092442">
            <i class="dont icon"></i>
            {{ getError() }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    room: require('@/components/rooms/Room').default,
    doctorVisits: require('@/components/doctors/Visits').default
  },
  data() {
    return {
      rooms: [],
      currentRoomId: null,
      currentDoctorId: null,
      useRooms: false,
      useDoctors: false,
      loading: false,
      roomKey: 0
    }
  },
  mounted () {
    if (this.settings[0].value.fields[0] === "doctor") {
      this.useDoctors = true
      this.useRooms = false
      this.currentDoctorId = this.getCurrentDoctorId()
    } else {
      this.loading = true
      this.useDoctors = false
      this.useRooms = true
      this.getRooms()
    }
  },
  methods: {
    getCurrentDoctorId () {
      if(this.$auth.check('employee') || this.isAdmin()) {
        return this.doctorsMeta[0].id
      } else {
        return this.$auth.user().profile.id
      } 
    },
    getRooms() {
      this.$http.get('rooms', {
        params: {
          clinic_id: this.getClinicId(),
        }
      }).then(response => {
        this.rooms = response.data
        if (this.filteredRooms().length) {
          this.currentRoomId = Number(this.filteredRooms()[0].id)
          ++this.roomKey
        }
        this.loading = false
      });
    },
    chooseRoom(roomId) {
      this.currentRoomId = Number(roomId)
      ++this.roomKey
    }, 
    chooseDoctor(doctorId) {
      this.currentDoctorId = Number(doctorId)
      ++this.roomKey
    }, 
    filteredRooms () {
      if(this.$auth.check('employee') || this.isAdmin()) {
        return this.rooms
      } 

      return this.rooms.filter(room => room.last_shift && room.last_shift.doctor_id === this.$auth.user().profile.id)
    },
    filteredDoctors () {
      if(this.$auth.check('employee') || this.isAdmin()) {
        return this.doctorsMeta
      } 

      return this.doctorsMeta.filter(doctor => doctor.id === this.$auth.user().profile.id)
    },
    getError() {
      if (this.useRooms) {
        if (this.$auth.check('employee')) {
          return 'Contact the admin to start configuring the rooms.'
        }
        if (this.isAdmin()) {
          return 'Your rooms not configured yet. You can configure it from clinic settings'
        }
  
        if (this.rooms.length) {
          return 'Shift not started'
        } else {
          return 'Contact the admin to start configuring the rooms.'
        }
      } else {
        return 'There is no doctors configured on your system yet.'
      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue